import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { DataProvider } from "./context/DataContext";
import LoginScreen from "./pages/LoginScreen";
import OrdersScreen from "./pages/OrdersScreen";
import MyOrdersScreen from "./pages/MyOrdersScreen";
import ReportsScreen from "./pages/ReportsScreen";
import SettingsScreen from "./pages/SettingsScreen";
import ReportScreen from "./pages/ReportScreen";
import OrderDetailScreen from "./pages/OrderDetailScreen";
import ForgotPasswordScreen from "./pages/ForgotPasswordScreen";
import "./App.css";

function RequireAuth({ children }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="flex-1 flex items-center justify-center">Загрузка...</div>;
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

function MainTabs() {
    return (
        <div className="flex flex-col h-screen">
            <div className="flex-1 overflow-y-auto pb-16">
                <Routes>
                    <Route path="/orders" element={<OrdersScreen />} />
                    <Route path="/my-orders" element={<MyOrdersScreen />} />
                    <Route path="/reports" element={<ReportsScreen />} />
                    <Route path="/settings" element={<SettingsScreen />} />
                    <Route path="/order/:orderId" element={<OrderDetailScreen />} />
                    <Route path="/report" element={<ReportScreen />} />
                    <Route path="*" element={<Navigate to="/orders" />} />
                </Routes>
            </div>
            <nav className="fixed bottom-0 left-0 right-0 h-14 bg-white border-t flex justify-around items-center">
                <NavButton to="/orders" icon="📋" label="Заказы" />
                <NavButton to="/my-orders" icon="📦" label="Мои" />
                <NavButton to="/reports" icon="📊" label="Отчеты" />
                <NavButton to="/settings" icon="⚙️" label="Ещё" />
            </nav>
        </div>
    );
}

function NavButton({ to, icon, label }) {
    const isActive = window.location.pathname.startsWith(to);
    return (
        <a href={to} className={`flex flex-col items-center text-xs ${isActive ? "text-blue-500" : "text-gray-500"}`}>
            <span className="text-xl">{icon}</span>
            <span>{label}</span>
        </a>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <DataProvider>
                    <Routes>
                        <Route path="/login" element={<LoginScreen />} />
                        <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
                        <Route
                            path="/*"
                            element={
                                <RequireAuth>
                                    <MainTabs />
                                </RequireAuth>
                            }
                        />
                    </Routes>
                </DataProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}
